import { FiltersRoot } from './filters-root';
import { FiltersBar } from './filters-bar';
import { FiltersSearch } from './filters-search';
import { FiltersSelect } from './filters-select';
import { FiltersMultiselect } from './filters-multiselect';
import { FiltersDateRange } from './filters-date-range';
import { FiltersClear } from './filters-clear';

/**
 * `Filters` — a compound, URL-search-param-driven filter bar.
 *
 * The URL is the single source of truth (CLAUDE.md state-boundary table).
 * Subcomponents read/write search params directly via the router, so a page
 * composes them with no navigate glue:
 *
 * ```tsx
 * <Filters.Root managedKeys={['search', 'status']}>
 *   <Filters.Search paramKey="search" placeholder="Search orders…" />
 *   <Filters.Select paramKey="status" options={statusOptions} allLabel="All statuses" />
 *   <Filters.Clear watchKeys={['search', 'status']} />
 * </Filters.Root>
 * ```
 */
export const Filters = {
  Root: FiltersRoot,
  Bar: FiltersBar,
  Search: FiltersSearch,
  Select: FiltersSelect,
  Multiselect: FiltersMultiselect,
  DateRange: FiltersDateRange,
  Clear: FiltersClear,
};

export { useFiltersContext } from './filters-context';

export type { FiltersRootProps } from './filters-root';
export type { FiltersBarProps } from './filters-bar';
export type { FiltersSearchProps } from './filters-search';
export type { FiltersSelectProps, FiltersSelectOption } from './filters-select';
export type { FiltersMultiselectProps } from './filters-multiselect';
export type { FiltersDateRangeProps } from './filters-date-range';
export type { FiltersClearProps } from './filters-clear';
